import { ElementRef, Component, Input } from '@angular/core'

import { animate, style, transition, trigger, state } from '@angular/animations'

@Component({
    selector: 'app-drop-down-menu',
    template: `
    <div class="setup-container" [@dropDown]="state" (@dropDown.done)="onAnimationDone()">
      <div *ngIf="!disableDropDown" class="setup-title disable-selection" (click)="onExpand(expandImage)">
        {{ menuTitle }}
        <span class="expand">
          <img class="expand-image disable-selection" #expandImage id="expandImage" name="expandImage" src="/assets/shared/expand-black.svg" />
        </span>
        <div *ngIf="subTitle && expand.show" class="subtitle">{{ subTitle }}{{ subTitleContent }}</div>
        <hr *ngIf="hrEnabled && expand.show" />
      </div>
      <div *ngIf="disableDropDown" class="setup-title disable-selection">
        {{ menuTitle }}
        <div *ngIf="subTitle && expand.show" class="subtitle">{{ subTitle }}{{ subTitleContent }}</div>
        <hr *ngIf="hrEnabled && expand.show" />
      </div>
      <div [ngClass]="maxHeight ? 'max-height' : ''">
        <ng-content></ng-content>
      </div>
    </div>
  `,
    styles: [
        `
      .setup-container {
        width: 100%;
        background-color: white;
        border-radius: 20px;
        padding: 32px 32px 32px 32px;
        display: flex;
        flex-direction: column;
        margin-bottom: 24px;
      }
      .max-height {
        overflow: hidden;
      }
      .setup-title {
        font-family: 'Poppins-SemiBold';
        font-size: 18px;
        font-style: normal;
        line-height: 150%;
        background-color: transparent;
        color: #222222;
        margin: 0;
        letter-spacing: 0.5px;
        padding: 32px 32px;
        margin: -32px -32px 0px -32px;
        cursor: pointer;
      }
      .disable-selection {
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
      }
      .expand-image {
        transform: rotate(180deg);
      }
      .expand {
        float: right;
      }
      .subtitle {
        width: 150px;
        height: 19px;
        font-family: 'Poppins-Regular';
        font-size: 16px;
        font-style: normal;
        line-height: 150%;
        margin: 0;
        background-color: transparent;
        letter-spacing: 0.1px;
        color: #333333;
      }
      hr {
        display: block;
        margin-top: 0.1em;
        margin-bottom: 0;
        margin-left: auto;
        margin-right: auto;
        border-style: inset;
        border-width: 1px;
        background-color: #c8c7cc;
        width: 100%;
        margin: 16px 0 0 0;
      }
    `,
    ],
    animations: [trigger('dropDown', [state('initial', style({ height: '90px' })), state('final', style({ height: '*' })), transition('initial=>final', animate('150ms ease-out')), transition('final=>initial', animate('150ms ease-out'))])],
    standalone: false
})
export class DropDownMenuComponent {
  @Input() menuTitle: string
  @Input() disableDropDown = false
  @Input() subTitle: string
  @Input() subTitleContent: string
  @Input() hrEnabled = false

  public maxHeight = false
  public state = 'final'
  public expand = { show: true }

  constructor(private element: ElementRef) {}

  onExpand(image) {
    this.expand.show = !this.expand.show
    image.style.transform = `rotate(${this.expand.show ? 180 : 0}deg)`
    this.state = this.state === 'initial' ? 'final' : 'initial'
    if (this.state === 'initial') {
      this.maxHeight = true
    }
  }

  onAnimationDone() {
    if (this.state === 'final') {
      this.maxHeight = false
    }
  }
}
